export const getPlaceIdFromPathname = (pathname) => {
  const match = pathname.match(/\/(\d+)$/);
  if (match && match[1]) {
    return match[1];
  }
  return null;
};
